import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AccessMediaReaderState } from "./access-media-reader.state";

export const selectAccessMediaReaderState = createSelector(
    createFeatureSelector('accessMediaReaderState'),
    (state: AccessMediaReaderState) => {
        return state;
    }
);